<div class="container">
  <div class="d-flex align-items-center mt-3 pt-3 pb-4">
    <!-- Back Button -->
    <div class="text-danger cursor-pointer back-button d-flex align-items-center" [routerLink]="'/rewards/wallet'">
      <span class="icon material-icons fw-bold pe-2">chevron_left</span>
      <span class="font-size-14 fw-bold">{{ 'claimed.back.to.wallet' | translate }}</span>
    </div>
  </div>

  <!-- V2 expired offers -->
  <fgb-campaigns-v2-used-offers-list></fgb-campaigns-v2-used-offers-list>

  <!-- Items history -->
  <ng-container
    *ngIf="
      {
        walletItemsClaimed: walletItemsClaimed$ | async,
      } as walletItems;
      else noWalletItems
    "
  >
    <ng-container *ngIf="walletItems.walletItemsClaimed && walletItems.walletItemsClaimed.length; else noWalletItems">
      <h5 class="m-0 text-grey wallet-redeemed-title text-capitalize font-size-18 pb-2 pt-4">
        {{ 'wallet.redeemed.item.history.title' | translate }}
      </h5>
      <fgbcl-rewards-wallet-redeemed-list
        [redeemedItems]="walletItems.walletItemsClaimed"
        [style]="'list'"
      ></fgbcl-rewards-wallet-redeemed-list>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="transferredItems$ | async as transferredItems">
    @if (transferredItems?.length > 0) {
      <h5 class="font-size-18 pt-4 pb-2 text-grey">{{ 'wallet.transferred.list.title' | translate }}</h5>
      <fgbcl-wallet-transferred-list />
    }
  </ng-container>
</div>

<ng-template #noWalletItems>
  <div class="container">
    <div class="border">
      <div class="fw-bold font-size-12 text-center text-grey py-3">
        {{ 'claimed.rewards.placeholder.description' | translate }}
      </div>
    </div>
  </div>
</ng-template>
